/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { REGEX_PHONE, REGEX_EMAIL } from "../../util/RegEx";
import { Grid, TextField, Button, Box, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Divider } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close, Search, LinkOff } from "@mui/icons-material";
import { permissions } from "../../util/DataObject";
import { useConfirm } from "./confirm";

const AddAbbUser = (props) => {
  const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [codeCom, setCodeCom] = useState("52");
  const [errCodeCom, setErrCodeCom] = useState(false);

  const [search, setSearch] = useState("");
  const [start, setStart] = useState(false);
  const [searchCompany, setSearchCompany] = useState("");
  const [companies, setCompanies] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [searchType, setSearchType] = useState('uuid');
  const [companiesEdit, setCompaniesEdit] = useState([]);
  const [spaces, setSpaces] = useState([]);

  const [assign, setAssign] = useState(false);
  const [uuid, setUuid] = useState("");
  const [show, setShow] = useState(false);
  const history = useHistory();
  const [form, setForm] = useState({ email: "", phone: "", gname: "", lname: "", slname: "", company: [], account_acl: [], status: "" });
  const [oldData, setOldData] = useState({ email: "", phone: "", gname: "", lname: "", slname: "", company: [], account_acl: [], status: "" });

  const [errs, setErrs] = useState({
    admin: [{ email: false, phone: false, gname: false, lname: false, slname: false }],
    company: [{ name: false, uuid: false }],
    account_acl: [{ space_uuid: false, permission: false }],
  });

  const { DialogConfirm, confirm: confirmUpdateStatus } = useConfirm(
    'Actualizar administrador',
    '¿Estás seguro que deseas realizar este cambio? Recuerda que el cambio de correo y teléfono sólo se podrá realizar dos veces al mes'
  )

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    setSearch("");
    setSearchCompany("");

    if (props.contentModal.item) {
      let agentInfo = props.contentModal.item;
      let f = form;
      let er = errs;
      let k = Object.keys(agentInfo);

      for (let i = 0; i < k.length; i++) {
        if (k[i] === "admin") {
          Object.keys(agentInfo[k[i]]).map((v) => {
            if (f.hasOwnProperty(v)) {
              if (v === "phone") {
                var code = agentInfo[k[i]][v].slice(1,3)
                setCodeCom(code)
                f[v] = agentInfo[k[i]][v].split(`+${code}`)[1];
              } else {
                f[v] = agentInfo[k[i]][v];
              }          
            }
          });
        } else {
          if (f.hasOwnProperty(k[i])) {
            f[k[i]] = agentInfo[k[i]];
          }
        }
        if (k[i] === "company") {
          setCompaniesEdit(agentInfo[k[i]]);
        }
      }

      setShow(true);
      verifyForm(f, er);
      setUuid(agentInfo.uuid);
      setForm(JSON.parse(JSON.stringify(f)));
      setOldData(JSON.parse(JSON.stringify(f)));
      agentInfo.company.map(async (a) => {
        await getSpaces(a.uuid);
      });
    }

    if (!props.contentModal.hasOwnProperty("userList")) {
      setShow(false);
      setAssign(true);
    }
  };

  const verifyForm = (data, e) => {
    let cont = 1;
    let verify = 1;
    let keysForm = Object.keys(data);

    for (let i = 0; i < keysForm.length; i++) {
      if (keysForm[i] === "email" || keysForm[i] === "phone") {
        cont = cont * (data[keysForm[i]] ? 1 : 0);
        verify = verify * (e[keysForm[i]] ? 0 : 1);
      }
    }

    if (cont * verify) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const change = async (field1, field2, field3, e) => {
    let f = form;
    let er = errs;

    if (field1 === "admin") {
      f[field2] = e.target.value;
    }

    if (field1 === "company") {
      let newCompany = f["company"];
      let validate = newCompany.filter((a) => a.name === e.target.value).length === 0 
      setCompanyName("");
      
      await companies.map(async (i) => {
        if (i.corporate_name === e.target.value && validate) {
          let spacesGet = await getSpaces(i.uuid);
          if(spacesGet){
            newCompany.push({
              name: i.corporate_name,
              rol: [{ uuid: props.roles[0]?._id }],
              uuid: i.uuid,
            });
            f["company"] = newCompany;     
            setCompanyName(e.target.value);
            setForm(JSON.parse(JSON.stringify(f)));
          }
        }
      });
    }

    if (field2 === "rol") {
      f[field1].map((r, index) => {
        if(r.uuid === field3){
          f[field1][index][field2][0]["uuid"] = e.target.value;
        }
      })
    }

    if (field1 === "account_acl") {
      const addSpace = () => {
        f[field1].splice(field3, 0,{
          space_uuid: field2,
          permission: e.target.value,
        });
      };
      
      if (f[field1].length > 0) {
        f[field1]?.map((i, index) => {
          if (i["space_uuid"] === field2) {
            return (f[field1][index]["permission"] = e.target.value);
          }
          if (!Object.values(f[field1]?.map((i) => { return i.space_uuid })).includes(field2)) {
            return addSpace();
          }
        });
      } else {       
        if (spaces.length === 1) {
          setShow(true);
        }
        return addSpace();
      }
      if (f[field1].length >= spaces.length) {
        setShow(true);
      }
    }

    if (!e?.target?.value) {
      er[field1][0][field2] = true;
    } else {
      er[field1][0][field2] = false;
    }

    if (field2 == "code") {
      setCodeCom(e.target.value);
      if (!e.target.value) {
        setErrCodeCom(true);
      } else {
        setErrCodeCom(false);
      }
    }

    if (field2 == "email") {     
      if (!REGEX_EMAIL.test(e.target.value)) {
        er[field2] = true;
      } else {
        er[field2] = false;
      }
    }

    if (field2 == "phone") {
      if (e.target.value.includes("+")) {
        if (!REGEX_PHONE.test(e.target.value)) {
          er[field2] = true;
        } else {
          er[field2] = false;
        }
      } else {
        if (!REGEX_PHONE.test(`+${codeCom}${e.target.value}`)) {
          er[field2] = true;
        } else {
          er[field2] = false;
        }
      }
    }

    verifyForm(f, er);
    setErrs(JSON.parse(JSON.stringify(er)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const changeTypeSearch = (e) => {
    setSearchType(e.target.value)
  }

  const create = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = form;
    data["phone"] = `+${codeCom}${data["phone"]}`;

    let response = await API.service( "addAbbUser", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (response.status === 200) {
      if (response.data.data.response == "OK") {
        await props.changePage(props.currentPage);
        props.changeAlert(true, "success", "Usuario creado con éxito");
        closelightbox();
      } else {
        let f = form;
        f["phone"] = f["phone"].replace(`+${codeCom}`, "");
        setForm(JSON.parse(JSON.stringify(f)));
        let detail = response.data.data.message;
        props.changeAlert(true, "error", "Error al crear Usuario. " + detail);
      }
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const update = async () => {
    let isConfirm = null
    if(form.email === oldData.email && form.phone === oldData.phone){
      isConfirm = true
    } else {
      isConfirm = await confirmUpdateStatus()
    }
    if (isConfirm) {
      props.changeLoader(true);
      setZPos(-1)
      let data = form;
  
      data["phone"] = `+${codeCom}${data["phone"]}`;
      data["uuid"] = uuid
  
      let response = await API.service( "updateAbbUser", data, props.pos, props.changeAlert, props.changeLoader, history );
      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          await props.changePage(props.currentPage);
          props.changeAlert(true, "success", "Usuario editado con éxito");
          closelightbox();
        } else {
          let f = form;
          f["phone"] = f["phone"].replace(`+${codeCom}`, "");
          setForm(JSON.parse(JSON.stringify(f)));
          let detail = response.data.data.message;
          props.changeAlert(true, "error", "Error al editar Usuario. " + detail);
        }
      }
      props.changeLoader(false);
      setZPos(45)
    } else {
      return
    }    
  };

  const deleteCompany = async (company) => {
    let f = form;

    f["company"].map((i, index) => {
      if (i.uuid === company.customer_uuid) {
        f["company"].splice(index, 1);
      }
    });

    let positions = [];
    spaces.map((i, index) => {
      if (i.customer_uuid === company.customer_uuid) {
        positions.unshift(index);
      }
    });
    positions.map((i) => {
      spaces.splice(i, 1);
      f["account_acl"].splice(i, 1);
    });

    setForm(JSON.parse(JSON.stringify(f)));
  };

  const changeText2 = (e) => {
    setSearchCompany(e.target.value);
  };

  const findCompany = async () => {
    props.changeLoader(true);
    setZPos(-1)
    setCompanyName("");
    let data = {
      customer: { keyword: searchCompany },
      filters: { 
        results_per_page: 20, 
        page_number: 1, 
        search_type: searchType 
      }
    };

    let request = await API.service( "afbCustomers", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      let company = request.data.data.widget[0].data.content;
      setCompanies(company);
      setStart(true);
      props.changeLoader(false);
      setZPos(45)
      return company;
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Ocurrió un error al realizar la consulta. " + detail);
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const getSpaces = async (uuid) => {
    props.changeLoader(true);
    setZPos(-1)

    let request = await API.service( "cuentas", uuid, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        let newSpaces = spaces;
        if (request.data.data.widget[1].data.content.length > 0) {
          request.data.data.widget[1].data.content.map((item) => {
            newSpaces.push(item);
          });

          setSpaces(JSON.parse(JSON.stringify(newSpaces)));
          props.changeLoader(false);
          setZPos(45)
          return true;
        } else {
          setCompanyName("");
          let detail = request.data.data.message;
          props.changeAlert(true, "error", "Ocurrió un error al realizar la consulta. " + detail);
        }
      }
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Ocurrió un error al realizar la consulta. " + detail);
    }

    props.changeLoader(false);
    setZPos(45)
  };

  var help = []

  return (
    <>
      <DialogConfirm />    
      <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
        <ModalStyle property={String(disabled)}>
          <DialogTitle>
            {assign ? "Asociar" : uuid ? "Editar" : "Crear nuevo"} usuario aBB
            <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
          </DialogTitle>
          
          <DialogContent>
            <Grid container display={"flex"} spacing={2} sx={{ marginTop: "10px" }}>
              <Grid item xs={9}>
                <TextField
                  label="Buscar empresa" value={searchCompany} onChange={changeText2.bind(this)} size="small" fullWidth
                  InputProps={{
                    endAdornment: (
                      <IconButton onClick={findCompany.bind(this)}>
                        <Search cursor={"pointer"} />
                      </IconButton>
                    ),
                  }}
                />

              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Tipo" value={searchType} onChange={changeTypeSearch.bind(this)} select size="small" fullWidth >
                    <MenuItem value={"uuid"}>UUID</MenuItem>
                    <MenuItem value={"clabe"}>CLABE</MenuItem>
                    <MenuItem value={"email"}>Email</MenuItem>
                </TextField>
              </Grid>
              {start && (
                <Grid item xs={6}>
                  <TextField
                    label="Empresa" value={companyName} 
                    onChange={change.bind(this, "company", "name", null)} select size="small" fullWidth >
                    <MenuItem value={""} disabled>Seleccione</MenuItem>
                    {companies?.map((i, index) => (
                      <MenuItem key={index} value={i.corporate_name}>{i.corporate_name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              {spaces.length > 0 &&
                <div style={{display: "contents", maxHeight: "275px", overflowY: spaces.length > 3 ? "scroll" : "inherit"}}>            
                  <Grid container spacing={2} ml={"auto"}>
                    <Grid item xs={1} mt={2}><em>Roles</em></Grid>
                    <Grid item xs={11} mt={4}><Divider /></Grid>
                  </Grid>
                  {form.company.map((r) => {                        
                    return (
                      <Grid container spacing={2} key={r.uuid} sx={{ marginTop: "10px", paddingLeft: "16px" }} >
                        <Grid item xs={6}>
                          <TextField label="Rol" value={(r?.rol && r?.rol[0]?.uuid) || ""} onChange={change.bind(this, "company", "rol", r.uuid)} select size="small" fullWidth >
                          {props.roles.map((rol) => {
                            return (<MenuItem key={rol.uuid} value={rol.uuid}>{rol.name}</MenuItem>);
                            })}
                          </TextField>
                        </Grid>
                        <Grid item xs={6}>
                          <Box style={{display: "flex", width: "inherit" }}>
                            <p style={{padding: "5px 10px 0px", fontSize: 16}}>{r.name}</p>
                          </Box>
                        </Grid>
                      </Grid>
                    )
                  })}
                  <Grid container spacing={2} ml={"auto"}>
                    <Grid item xs={2} mt={2}><em>Cuentas</em></Grid>
                    <Grid item xs={10} mt={4}><Divider /></Grid>
                  </Grid>
                  {spaces.map((i, index) => {  
                    return (
                      <Grid key={`${i.uuid}-${index}`} container spacing={2} sx={{ marginTop: "10px", paddingLeft: "16px" }} >
                        {form.company.map((c) => {
                          if(i.customer_uuid === c.uuid){
                            return (
                            <Box style={{display: "flex", width: "inherit" }} key={i.accountNumber}>
                              <IconButton style={{padding: "0px", marginLeft: "16px" }} onClick={deleteCompany.bind(this, i)}>
                                <LinkOff cursor={"pointer"} />
                              </IconButton>
                              <p style={{padding: "5px 10px 0px", fontSize: "12px"}}><em>{c.name}</em></p>
                            </Box>
                          )}
                        })}

                        <Grid item xs={6}>
                          <TextField
                            label="Número de cuenta" value={i.accountNumber} size="small" fullWidth disabled
                          />
                        </Grid>
                        <Grid item xs={6}>
                          {form.account_acl.length > 0 ? form.account_acl.map((acc, indexAcc) => {   
                              if(acc.space_uuid === i.uuid || (form.account_acl.length -1 === indexAcc && help.indexOf(i.uuid) === -1) ){
                                help.push(i.uuid)
                                return <TextField key={`${acc.permission}- ${indexAcc}`} label="Permiso" value={acc.space_uuid === i.uuid ? acc.permission : ""} onChange={change.bind(this, "account_acl", i.uuid, index)} select size="small" fullWidth >
                                  {permissions.map((p) => {
                                    return <MenuItem key={p.key} value={p.key}>{p.label}</MenuItem>
                                  })}
                                </TextField>
                              }
                            }) :
                            <TextField label="Permiso" value={form.account_acl[index]?.permission || ""} onChange={change.bind(this, "account_acl", i.uuid, null)} select size="small" fullWidth >
                              {permissions.map((p) => {               
                                return <MenuItem key={p.key} value={p.key}>{p.label}</MenuItem>
                              })}
                            </TextField>                          
                          }
                        </Grid>
                      </Grid>
                    );
                  })}
                </div>
              }

              {show && (
                <>
                  <Grid container spacing={2} ml={"auto"}>
                    <Grid item xs={3} mt={2}><em>Administrador</em></Grid>
                    <Grid item xs={9} mt={4}><Divider /></Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Nombre(s)" value={form.gname} onChange={change.bind(this, "admin", "gname", null)} size="small" fullWidth error={errs.admin[0].gname} helperText={errs.admin[0].gname ? "Dato obligatorio" : ''}/>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Apellido paterno" value={form.lname} onChange={change.bind(this, "admin", "lname", null)} size="small" fullWidth error={errs.admin[0].lname} helperText={errs.admin[0].lname ? "Dato obligatorio" : ''}/>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Apellido materno" value={form.slname} onChange={change.bind(this, "admin", "slname", null)} size="small" fullWidth error={errs.admin[0].slname} helperText={errs.admin[0].slname ? "Dato obligatorio" : ''}/>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Correo electrónico" value={form.email} onChange={change.bind(this, "admin", "email", null)} size="small" fullWidth error={errs.admin[0].email} helperText={errs.admin[0].email ? "Dato obligatorio" : ''}/>
                  </Grid>
                  <Grid item xs={8} sx={{ display: "flex" }}>
                    <TextField
                      label="Código país" value={codeCom} onChange={change.bind(this, "admin", "code", null)} select size="small" sx={{ marginRight: "10px" }} style={{ width: "45%" }} name="user.code"
                    >
                      {props.catalogs.country.map((item, index) => {
                        return (
                          <MenuItem key={`state-${index}`} value={item.m[0].dial}>
                            (+{item.m[0].dial}) {item.m[0].code2}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <TextField
                      label="Teléfono" value={form.phone} onChange={change.bind(this, "admin", "phone", null)} placeholder="Teléfono" name="user.phone" size="small" style={{ width: "55%" }} InputProps={{ style: { height: "40px"}}}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>

          <DialogActions>    
            <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
            <Button disabled={disabled} variant="contained" onClick={assign || uuid ? update.bind(this) : create.bind(this)} >{assign ? "Asociar" : uuid ? "Editar" : "Crear"} usuario</Button>
          </DialogActions>
        </ModalStyle>
      </Dialog>
    </>
  );
};

export default AddAbbUser;
